import React, { useState, useRef } from "react";
import CrossIcon from "assets/images/icons/cross-icon.svg"
import SaveIcon from "assets/images/icons/Save-icon.svg"
import { HandleAdd, handleChange as tableHandleChange, handleDelete, handlEdit, handleSave } from "utils/TableFunctions";
import CustomButton from "shared/CustomButton";
import { CustomAmountInput, CustomDropDown, CustomForm } from "shared/AllInputs";
import CustomOverlay from "shared/CustomOverlay";
import DeleteModal from "shared/Modals/DeleteModal";
import { TenantsOptions } from "shared/AllDropDownOptions";
import EuroIcon from "assets/images/svg/euroIcon.svg"
import SizeM2 from "assets/images/svg/SizeM2.svg"

const AddBaseRentTable = ({
    customHeader,
    allValues,
    setAllValues,
}) => {
    const openAction = useRef(null);
    const InputObj = {
        id: "",
        number_of_tenant: "",
        abstract_allowed_size: "",
        net_rent: "",
        gross_base_rent: "",
    };

    const ignoreInputs = ["status", "id"];
    const [deleteModal, setDeleteModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [idToDelete, setIdToDelete] = useState("");

    const onDelete = () => {
        handleDelete(allValues, setAllValues, idToDelete);
        setIdToDelete("");
        setDeleteModal(false);
    };

    const header = (
        <div className="flex justify-content-between w-full">
            <div className="flex justify-content-end flex-wrap">
                <CustomButton
                    type="button"
                    label="Add"
                    onClick={() => HandleAdd(InputObj, allValues, setAllValues)}
                />
            </div>
        </div>
    );

    return (
        <>
            <CustomForm header={customHeader || header} col={12}>
                <div className="overflow-auto w-full">
                    <table className="financial-table editor-container w-12 mt-3 table-error-align border-300 w-full border-round-lg">
                        <thead>
                            <tr>
                                <th>No. of Tenants</th>
                                <th>Abtracted Allowed Size</th>
                                <th>Net Rent by Sqm</th>
                                <th>Gross Base Rent</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody id="" className="cell-width">
                            {allValues?.map((item, index) => {
                                return (
                                    <React.Fragment key={index}>
                                        <tr>
                                            <td className={` ${item.status === 'save' ? 'p-disabled' : ''}`}>
                                                <CustomDropDown
                                                    data={item}
                                                    options={TenantsOptions}
                                                    name="number_of_tenant"
                                                    col={12}
                                                    ignoreLabel
                                                    onChange={({ name, value }) => {
                                                        tableHandleChange(name, value, index, allValues, setAllValues, ["id", "status"])
                                                    }}
                                                />
                                            </td>
                                            <td>
                                                <CustomAmountInput
                                                    extraClassName="w-full p-0"
                                                    inputClass="m-0"
                                                    data={item}
                                                    col={12}
                                                    onChange={({ name, value }) => tableHandleChange(name, value, index, allValues, setAllValues, ["id", "status"], [""], item?.type)}
                                                    name="abstract_allowed_size"
                                                    disabled={item?.status === "save" ? true : false}
                                                    spanIcon={SizeM2}
                                                    spanExtraClassName={"p-2"}
                                                    ignoreLabel
                                                />
                                            </td>
                                            <td>
                                                <CustomAmountInput
                                                    inputClass="m-0"
                                                    data={item}
                                                    onChange={({ name, value }) =>
                                                        tableHandleChange(
                                                            name,
                                                            value,
                                                            index,
                                                            allValues,
                                                            setAllValues,
                                                            ignoreInputs
                                                        )
                                                    }
                                                    name="net_rent"
                                                    col={12}
                                                    disabled={item?.status === "save" ? true : false}
                                                    ignoreLabel
                                                    spanIcon={EuroIcon}
                                                />
                                            </td>
                                            <td>
                                                <CustomAmountInput
                                                    data={item}
                                                    inputClass="m-0"
                                                    onChange={({ name, value }) =>
                                                        tableHandleChange(
                                                            name,
                                                            value,
                                                            index,
                                                            allValues,
                                                            setAllValues,
                                                            ignoreInputs
                                                        )
                                                    }
                                                    name="gross_base_rent"
                                                    col={12}
                                                    disabled={item?.status === "save" ? true : false}
                                                    ignoreLabel
                                                    spanIcon={EuroIcon}
                                                />
                                            </td>
                                            {item?.status === "save" ? (
                                                <td style={{ "minWidth": "20px" }}>
                                                    <CustomOverlay ref={openAction}>
                                                        <ul className="no-style p-0">
                                                            <li
                                                                className="flex gap-2 text-xs font-medium mb-3 cursor-pointer"
                                                                onClick={() =>
                                                                    handlEdit(allValues, setAllValues, index)
                                                                }
                                                            >
                                                                <i className="pi pi-file-edit text-dark"></i>
                                                                Edit
                                                            </li>
                                                            <li
                                                                className="flex gap-2 text-xs font-medium mb-3 cursor-pointer"
                                                                onClick={() => {
                                                                    setIdToDelete(index);
                                                                    setDeleteModal(true);
                                                                }}
                                                            >
                                                                <i className="pi pi-trash cursor-pointer text-dark"></i>
                                                                Delete
                                                            </li>
                                                        </ul>
                                                    </CustomOverlay>
                                                </td>
                                            ) : (
                                                <td style={{ "minWidth": "20px" }} className="vertical-align-middle">
                                                    <div className="d-flex gap-3">
                                                        <a
                                                            className="cursor-pointer"
                                                            onClick={() =>
                                                                handleSave(
                                                                    index,
                                                                    allValues,
                                                                    setAllValues,
                                                                    ignoreInputs,
                                                                )
                                                            }
                                                        >
                                                            <img src={SaveIcon} />
                                                        </a>
                                                        <a
                                                            className="cursor-pointer"
                                                            onClick={() => {
                                                                handleDelete(allValues, setAllValues, index);
                                                            }}
                                                        >
                                                            <img src={CrossIcon} />
                                                        </a>
                                                    </div>
                                                </td>
                                            )}
                                        </tr>
                                        <DeleteModal
                                            isOpen={deleteModal}
                                            setIsOpen={setDeleteModal}
                                            onSubmit={onDelete}
                                            loading={loading}
                                            item={"link"}
                                        />
                                    </React.Fragment>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
                <br />
            </CustomForm>
        </>
    );
};

export default AddBaseRentTable;
